import React, { useState } from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import { brandIvory } from '../../../assets/consts/color'
import ButtonAtom from '../../atoms/buttons/buttons'
import { useIsMobile } from '../../../hooks/useIsMobile'
import SelectField from '../../atoms/fields/select'

const lessonTabList = ['Lesson 1', 'Lesson 2', 'Lesson 3', 'Lesson 4', 'Lesson 5', 'Lesson 6']

const lessonSelectOptions = [
  {
    label: 'Lesson 1',
    value: 0,
  },
  {
    label: 'Lesson 2',
    value: 1,
  },
  {
    label: 'Lesson 3',
    value: 2,
  },
  {
    label: 'Lesson 4',
    value: 3,
  },
  {
    label: 'Lesson 5',
    value: 4,
  },
  {
    label: 'Lesson 6',
    value: 5,
  },
]

const Container = styled.div`
  padding: 32px;
  margin: 0 auto;
  max-width: 1264px;

  background-color: ${brandIvory};
`
const TabWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;

  & > button {
    flex-grow: 1;
    height: auto;
    max-width: 196px;
    padding: 24px;
    justify-content: center;
  }
`

const VieoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;

  & > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

const getYouTubeLinkId = (link) => {
  try {
    const { searchParams } = new URL(link)
    return searchParams.get('v')
  } catch {
    return ''
  }
}

function FreeCourseList() {
  const data = useStaticQuery(graphql`
    query {
      contentfulPageProductInformation(productHandle: { eq: "dji-zenmuse-l1-workflow-course" }) {
        l1WorkflowCourseVideoList {
          title
          link
        }
      }
    }
  `)

  const videoList = data?.contentfulPageProductInformation?.l1WorkflowCourseVideoList || []

  const [currentTabIndex, setCurrentTabIndex] = useState(0)
  const isMobile = useIsMobile()

  const handleTabClick = (index) => setCurrentTabIndex(index)

  const handleTabChange = ({ target }) => setCurrentTabIndex(+target.value)

  return (
    <Container>
      <div className="margin-24">
        {isMobile ? (
          <SelectField
            labelText="Lessons"
            labelFor="Lessons"
            fieldId="Lessons"
            fieldName="Lessons"
            value={currentTabIndex}
            options={lessonSelectOptions}
            onChange={handleTabChange}
          />
        ) : (
          <TabWrapper>
            {lessonTabList.map((tab, index) =>
              currentTabIndex === index ? (
                <ButtonAtom buttonType="Primary Button Without Arrow" buttonCopy={tab} />
              ) : (
                <ButtonAtom
                  key={tab}
                  buttonType="Secondary Button Without Arrow"
                  buttonCopy={tab}
                  onClick={() => handleTabClick(index)}
                />
              )
            )}
          </TabWrapper>
        )}
      </div>
      <VieoContainer>
        <iframe
          src={`https://www.youtube.com/embed/${getYouTubeLinkId(videoList[currentTabIndex]?.link)}`}
          title={videoList[currentTabIndex].title}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
        />
      </VieoContainer>
    </Container>
  )
}

export default FreeCourseList
